export const customerFeedbackByBrand = {
	'24domino': [
		{
			customerName: 'Kenny Simon',
			message:
				'Everything has been great at 24Domino so far. Better user experience than other solutions and lots of exciting features. It is easy and straightforward. Support has been quick to reply. Highly recommended!',
		},
	],
};
